import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../../../services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';

@Component({
  selector: 'app-add-addon-dialog',
  templateUrl: './add-addon-dialog.component.html',
  styleUrls: ['./add-addon-dialog.component.css']
})
export class AddAddonDialogComponent implements OnInit {
  api_error: any;
  addondisply: any;
  api_success: string;
  addons: any = [];
  addonname: any = [];
  disableConfirmbtn = false;
  description: string;
  addondisplyy: string;
  addonIds: string;
  type: any;
  metricName: any = [];
  addonsList: any = [];
  addonId_list:any=[];
  addons_conf;
  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountService: AccountService,
    private corporateService: CorporateService) { 
      
    }
  ngOnInit() {
    this.addondisply = ['Cloud Storage'];
    this.type = this.data['type'];
    this.accountService.getupgradableAddonss(this.data.accountId)
      .subscribe(res => {
        let addons_applied = [];
        // let addons_conf: any = [];
        addons_applied = this.data['addon'];
        let number_of_addons:any=[];
        for (let j = 0; j < addons_applied.length; j++) {
          
           number_of_addons.push(addons_applied[j].licPkgOrAddonId)
          }
          this.addonId_list=number_of_addons;
        this.addons_conf = res;
        for (let j = 0; j < this.addons_conf.length; j++) {
          for (let k = 0; k < this.addons_conf[j].addons.length; k++) {
            this.addons.push(this.addons_conf[j].addons[k]);
            // if (!this.isAddonExists(this.addons_conf[j].addons[k], addons_applied)) {
             
            // }
          }
        }
        for (let disply of this.addons_conf) {
          this.metricName.push(disply.metricDisplayName);
        }
        // let name = '';
        // addons_conf = res;
        // for (let i = 0; i < this.addons_conf.length; i++) {
        //     name = this.addons_conf[i].metricDisplayName;
        //     break;
        // }
        // console.log(name);
      });
  }
  isAddonExists(addon, addons_applied) {
    let isexists = false;
    if (this.data['type'] === 'account') {
      for (let i = 0; i < addons_applied.length; i++) {
        if (addons_applied[i].licPkgOrAddonId === addon.addonId) {
          isexists = true;
        }
      }
    } else if (this.data['type'] === 'corporate') {
      for (let i = 0; i < addons_applied.length; i++) {
        if (addons_applied[i].addonId === addon.addonId) {
          isexists = true;
        }
      }
    }
    return isexists;
  }
  isAddonSaved(addon, addons_applied) {
    let issaved = false;
      for (let i = 0; i < addons_applied.length; i++) {
        if (addons_applied[i]=== addon.addonId) {
          issaved = true;
        }
      }
    
    return issaved;
  }
  addonClick(addondisply) {
    const metriclist = this.addons_conf.filter(addon => (addon.metricDisplayName === addondisply));
    const newmetriclist=[];
      for (let j = 0; j < metriclist[0].addons.length; j++) {
        newmetriclist.push(metriclist[0].addons[j]);
        // if (!this.isAddonSaved(metriclist[0].addons[j], this.addonId_list)) {
        //   newmetriclist.push(metriclist[0].addons[j]);
        // }
      }
    // console.log(newmetriclist);
    this.addonsList = newmetriclist;
  }

  onChange(addonList) {
    let addonDesc = '';
    let addonId = '';
    console.log(addonList)
    console.log(this.addons)
    addonList.forEach((e1) => this.addons.forEach((e2) => {
      if (e1 === e2.addonId) {
        if (addonDesc !== '') {
          addonDesc = addonDesc + ',' + e2.addonDesc;
          addonId = addonId + ',' + e2.addonId;
        } else {
          addonDesc = e2.addonDesc;
          addonId = e2.addonId;
        }
      }
    }));
    this.description = addonDesc;
    this.addonIds = addonId;
  }
  onChangeCorporateAddon(addonlist) {
    console.log('addonId......' + addonlist);
    this.addons.forEach((e2) => {
      // tslint:disable-next-line:triple-equals
      if (addonlist == e2.addonId) {
        this.description = e2.addonDesc;
        this.addonIds = addonlist;
        console.log('description........' + e2.addonDesc);
      }
    });
  }
  submitAddon() {
    this.api_error = '';
    this.api_success = '';
    console.log('addons..' + this.addonIds);
    if (this.addonIds === '' || this.addonIds === 'undefined') {
      this.api_error = 'please select addon';
    } else {

      this.disableConfirmbtn = true;
      if (this.data['type'] === 'account') {
        const data = {
          accountId: this.data['accountId'],
          addonIds: this.addonIds
        };
        this.accountService.addAddons(data)
          .subscribe(
            res => {
              this.api_success = 'Addon added Successfully';
              setTimeout(() => {
                this.dialogRef.close('reloadlist');
              }, 2000);
            },
            (error) => {
              this.api_error = error.error;
              this.disableConfirmbtn = false;
            }
          );
      } else if (this.data['type'] === 'corporate') {
        this.corporateService.addAddon(this.data['corpId'], this.addonIds)
          .subscribe(
            res => {
              this.api_success = 'Addon added Successfully';
              setTimeout(() => {
                this.dialogRef.close('reloadlist');
              }, 2000);
            },
            (error) => {
              this.api_error = error.error;
              this.disableConfirmbtn = false;
            }
          );
      }
    }
  }
  public closeDialog() {
    this.dialogRef.close();
  }
}